import cameralogo from "../../../../src/Images/cameralogo.png";

function RelatedBusinessList({ searchData, isMobile, handleSelect, handleGetCompanyName, handleMobPageVw, handleMobProfileVw }) {
    return (
        <>
            {searchData.length > 0 &&
                <div className="p-2">
                    <h5>Related Businesses</h5>
                </div>
            }
            {searchData?.map((item, index) => (
                <div
                    className="serchresutllogodetaildivflx"
                    key={index}
                    onClick={() => handleSelect(item)}
                >

                    <div className="serachresultlogoidiv">
                        <img src={item?.businessProfilePic || cameralogo} alt="..." />
                    </div>
                    <div className="serachresultdetailsdiv">
                        <h4 className="serctedheadrparatxt">
                            {item?.companyName} - {handleGetCompanyName(item?.companyTypeID)}
                        </h4>

                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                            {item?.businessProductCat?.map((it, idx) => (
                                <p
                                    key={idx}
                                    className="diisjadfebnclkmdgragjksopjkl"
                                    style={{ marginLeft: "2px", fontWeight: "bold" }}
                                >
                                    {it}
                                    {item?.businessProductCat.length > idx + 1 && " | "}
                                </p>
                            ))}
                        </div>

                        <p className="serchrelusubtparatxtmm">
                            {item?.aboutBusiness?.length > 165
                                ? item?.aboutBusiness.substring(0, 165) + "..."
                                : item?.aboutBusiness}
                        </p>

                        {isMobile && (
                            <div className="search-result-view" style={{ display: "flex" }}>
                                <button
                                    onClick={(e) => handleMobPageVw(e, item)}
                                    style={{ margin: "0.5em 1em 0.5em 0" }}
                                >
                                    View page
                                </button>
                                {item?.memberStatus && (
                                    <button
                                        onClick={(e) => handleMobProfileVw(e, item)}
                                        style={{ margin: "0.5em 0" }}
                                    >
                                        View profile
                                    </button>
                                )}
                            </div>
                        )}
                    </div>

                </div>

            ))}
        </>
    );
}
export default RelatedBusinessList;